// IE 2026 09 28 / ODOO-342342: «Бизнес-кейсы» — личные отметки: избранное (звезда), «пройдено» (дата), место в пути (номер шага).
// Хранит бэк (контракт v1 §6.2–6.4: строка @guide в USER.doc.pages, ключ базы; записи кейсов и столов не меняются); фронт — только методы
// widget_USE_CASE: toggle_favorite {id, on}, set_passed {id, passed}, set_position {path, step}, get_personal {ids?}.
//
// Оптимистично: значение меняется сразу (store.guideMarks — реактивно, меню и полоса перерисовываются), запрос уходит следом. Ответ ok —
// значение бэка (fav / done из ответа). Звезда всегда шлётся с явным on (без on бэк переключает — два быстрых клика дали бы гонку).
// IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Н1): бэк НЕ принял запись (роль «только чтение», фильтр записей учётки показа, ошибка, нет
// ответа) — значение клика остаётся, молча: без отката и без уведомления; оно же ложится в слой local (браузер: opts.saveLocal → localStorage
// стора), переживает перезагрузку. Подтверждённая позже запись того же ключа снимает его из local. Клик, перекрытый более поздним кликом того же
// ключа (свой запрос), local не трогает.
//
// Слои значения: over (клики сеанса) → local (не принятые бэком, из браузера) → base (снимок бэка: get_personal / ответы методов) →
// значение строки меню / _doc.personal формы (fallback вызывающего).
import { guideCases_count } from './guideCases.js'

const has = (o, k) => !!o && Object.prototype.hasOwnProperty.call(o, k)

export function marks_empty() {
    return { base: { fav: {}, done: {}, pos: {} }, over: { fav: {}, done: {}, pos: {} }, tok: { fav: {}, done: {}, pos: {} }, local: { fav: {}, done: {}, pos: {} }, seq: 0, epoch: 0, loadedAt: 0 }
}
// IE 2026 09 28 / ODOO-342342 (Н1): слой local из браузера ({fav: {id: bool}, done: {id: iso|null}, pos: {путь: n}}) — чужие ключи и типы отбрасываются
export function marks_localLoad(m, data) {
    if (!m) return m
    const out = { fav: {}, done: {}, pos: {} }
    const src = data && typeof data === 'object' ? data : {}
    for (const [k, v] of Object.entries(src.fav && typeof src.fav === 'object' ? src.fav : {})) out.fav[k] = !!v
    for (const [k, v] of Object.entries(src.done && typeof src.done === 'object' ? src.done : {})) out.done[k] = v ? String(v) : null
    for (const [k, v] of Object.entries(src.pos && typeof src.pos === 'object' ? src.pos : {})) { const n = Number(v); if (Number.isFinite(n) && n >= 0) out.pos[k] = n }
    m.local = out
    m.epoch++
    return m
}
export function marks_ensure(store) {
    if (!store.guideMarks || !store.guideMarks.base) store.guideMarks = marks_empty()
    return store.guideMarks
}

// ответ get_personal / personal из ответов методов → base: fav — список id, done — {id: iso}, pos — {путь: шаг}
export function marks_applyPersonal(m, personal) {
    if (!m || !personal || typeof personal !== 'object') return m
    if (Array.isArray(personal.fav)) { m.base.fav = {}; for (const id of personal.fav) m.base.fav[String(id)] = true }
    if (personal.done && typeof personal.done === 'object' && !Array.isArray(personal.done)) {
        m.base.done = {}
        for (const [id, v] of Object.entries(personal.done)) if (v) m.base.done[id] = String(v)
    }
    if (personal.pos && typeof personal.pos === 'object') {
        m.base.pos = {}
        for (const [id, v] of Object.entries(personal.pos)) { const n = Number(v); if (Number.isFinite(n) && n > 0) m.base.pos[id] = n }
    }
    m.epoch++
    return m
}

// личное одной записи из _doc.personal формы ({fav: bool, done: iso|null, pos: n}) → base для этого id (форма открыта — снимок свежий)
export function marks_applyRecord(m, id, personal) {
    if (!m || !id || !personal || typeof personal !== 'object') return m
    const key = String(id)
    if ('fav' in personal) { if (personal.fav) m.base.fav[key] = true; else delete m.base.fav[key] }
    if ('done' in personal) { if (personal.done) m.base.done[key] = String(personal.done); else delete m.base.done[key] }
    if ('pos' in personal) { const n = Number(personal.pos); if (Number.isFinite(n) && n > 0) m.base.pos[key] = n; else delete m.base.pos[key] }
    m.epoch++
    return m
}

// текущие значения: over → local (IE 2026 09 28 / ODOO-342342, Н1) → base → fallback (значение строки / формы)
export function marks_fav(m, id, fallback = null) {
    const k = String(id || '')
    if (!k) return null
    if (m && has(m.over.fav, k)) return !!m.over.fav[k]
    if (m && m.local && has(m.local.fav, k)) return !!m.local.fav[k]   // IE 2026 09 28 / ODOO-342342 (Н1)
    if (m && m.loadedAt) return !!m.base.fav[k]
    if (m && has(m.base.fav, k)) return true
    return fallback === null || fallback === undefined ? false : !!fallback
}
export function marks_done(m, id, fallback = null) {
    const k = String(id || '')
    if (!k) return null
    if (m && has(m.over.done, k)) return m.over.done[k] || null
    if (m && m.local && has(m.local.done, k)) return m.local.done[k] || null   // IE 2026 09 28 / ODOO-342342 (Н1)
    if (m && m.loadedAt) return m.base.done[k] || null
    if (m && has(m.base.done, k)) return m.base.done[k] || null
    return fallback || null
}
export function marks_pos(m, pathId, fallback = null) {
    const k = String(pathId || '')
    if (!k) return null
    if (m && has(m.over.pos, k)) return m.over.pos[k] || null
    if (m && m.local && has(m.local.pos, k)) return m.local.pos[k] || null   // IE 2026 09 28 / ODOO-342342 (Н1)
    if (m && has(m.base.pos, k)) return m.base.pos[k] || null
    const n = Number(fallback)
    return Number.isFinite(n) && n > 0 ? n : null
}

// IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): итоговое личное записи для _doc.personal формы — теми же слоями, что у навигатора (over → local → base →
// значение формы): кнопки шапки ★ / «Mark as done» (v-if бэка по _doc.personal) и пункт навигатора показывают одно и то же, в том числе после перезагрузки,
// когда отметка есть только в браузере (Н1). cur — нынешний _doc.personal. Возвращает новый объект или null, если менять нечего
export function marks_recordPersonal(m, id, cur) {
    const key = String(id || '')
    if (!m || !key) return null
    const c = cur && typeof cur === 'object' ? cur : {}
    const next = { ...c, fav: !!marks_fav(m, key, c.fav), done: marks_done(m, key, c.done) || null, pos: marks_pos(m, key, c.pos) || 0 }
    return (c.fav === next.fav && (c.done || null) === next.done && (c.pos || 0) === next.pos) ? null : next
}

const KIND = {
    fav: { method: 'toggle_favorite', params: (id, v) => ({ id, on: !!v }), fromAnswer: (a) => ('fav' in a ? !!a.fav : undefined), stat: 'fav' },
    done: { method: 'set_passed', params: (id, v) => ({ id, passed: !!v }), fromAnswer: (a) => ('done' in a ? (a.done || null) : undefined), stat: 'done' },
    pos: { method: 'set_position', params: (id, v) => ({ path: id, step: Number(v) || 0 }), fromAnswer: () => undefined, stat: 'pos' },
}
const okAnswer = (a) => !!a && typeof a === 'object' && (a.status === 'ok' || a.ok === true) && !a.error

// Поставить отметку. kind: fav | done | pos; value: fav — true/false, done — true/false (дата — от бэка; до ответа — сейчас), pos — номер шага (0 — снять).
// send(method, params) → Promise<ответ | null>. opts: now() → iso (тесты), saveLocal(local) — сохранить слой local в браузере (IE 2026 09 28 / ODOO-342342, Н1).
// Возвращает Promise<{ ok, value, rolledBack, local }> (rolledBack — всегда false с Н1: не принятое бэком остаётся в браузере)
export async function personal_set(m, kind, id, value, send, opts = {}) {
    const K = KIND[kind]
    const key = String(id || '')
    if (!K || !key || !m || typeof send !== 'function') return { ok: false, value: null, rolledBack: false }
    const nowIso = typeof opts.now === 'function' ? opts.now() : new Date().toISOString()
    const next = kind === 'fav' ? !!value : kind === 'done' ? (value ? (typeof value === 'string' ? value : nowIso) : null) : (Number(value) || 0)
    const token = ++m.seq
    if (!m.tok) m.tok = { fav: {}, done: {}, pos: {} }
    m.over[kind][key] = next
    m.tok[kind][key] = token   // чей это клик: ответ (подтверждение или «оставить в браузере») трогает ключ, только пока он держит значение этого клика
    m.epoch++
    guideCases_count(K.stat)
    let answer = null
    try { answer = await send(K.method, K.params(key, kind === 'done' ? !!next : next)) } catch (e) { answer = null }
    const mine = m.tok[kind][key] === token
    if (!m.local) m.local = { fav: {}, done: {}, pos: {} }
    const saveLocal = () => { if (typeof opts.saveLocal === 'function') { try { opts.saveLocal(m.local) } catch (e) { /* хранилище недоступно — слой живёт в памяти */ } } }
    if (okAnswer(answer)) {
        if (answer.personal) marks_applyPersonal(m, answer.personal)
        const v = K.fromAnswer(answer)
        if (mine) {
            const val = v !== undefined ? v : next
            m.over[kind][key] = val
            if (kind === 'fav') { if (val) m.base.fav[key] = true; else delete m.base.fav[key] }
            if (kind === 'done') { if (val) m.base.done[key] = val; else delete m.base.done[key] }
            if (kind === 'pos') { if (val) m.base.pos[key] = val; else delete m.base.pos[key] }
            if (has(m.local[kind], key)) { delete m.local[kind][key]; saveLocal() }   // IE 2026 09 28 / ODOO-342342 (Н1): бэк принял — браузерная копия не нужна
        }
        m.epoch++
        return { ok: true, value: mine ? m.over[kind][key] : next, rolledBack: false, local: false }
    }
    // IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Н1): не подтвердилось — значение клика остаётся (в браузере), молча; более поздний клик того же
    // ключа (свой запрос) не трогаем
    if (mine) {
        m.local[kind][key] = next
        delete m.tok[kind][key]
        m.epoch++
        guideCases_count('localKept')
        saveLocal()
    }
    return { ok: false, value: mine ? next : m.over[kind][key], rolledBack: false, local: mine }
}

// get_personal: снимок бэка целиком (fav / done / pos; ids — ещё просмотры этих кейсов). true — снимок принят
export async function personal_load(m, send, ids = null) {
    if (!m || typeof send !== 'function') return false
    let answer = null
    try { answer = await send('get_personal', ids && ids.length ? { ids } : {}) } catch (e) { answer = null }
    if (!okAnswer(answer) || !answer.personal) return false
    marks_applyPersonal(m, answer.personal)
    m.views = (answer.personal.views && typeof answer.personal.views === 'object') ? { ...(m.views || {}), ...answer.personal.views } : (m.views || {})
    m.loadedAt = Date.now()
    return true
}

export default { marks_empty, marks_ensure, marks_localLoad, marks_applyPersonal, marks_applyRecord, marks_fav, marks_done, marks_pos, marks_recordPersonal, personal_set, personal_load }   // IE 2026 09 29 / ODOO-342342 (Н1): + marks_localLoad; (приёмка ie-growth7 З1): + marks_recordPersonal
